export default __webpack_public_path__ + "static/media/A4T8Y1-min.9b8de0e1.jpg";